<template>
  <div class="calendar-view">
    <TimeList v-for="el in columns" :key="el._id" :itemID="el._id" />
  </div>
</template>

<style scoped>
.calendar-view {
  display: flex;
  flex-direction: row;
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import TimeList from "@/components/TimeList.vue";
import { DATE_UNITS } from "../structure";

export default {
  props: [],
  components: {
    TimeList,
  },
  computed: {
    columns() {
      return DATE_UNITS.map((unit) => getItem(unit + "s"));
    },
  },
  methods: {},
};
</script>
